(() => {
  const button = document.querySelector('.rabaq-wa-floating');
  if (!button) return;

  let scheduled = false;
  let mutationObserver;
  let resizeObserver;
  const barSelector = '.rabaq-cart-sticky, .rabaq-sticky-cart, sticky-add-cart.sticky_mobile--show, sticky-add-cart.sticky_desktop--show';

  function refresh() {
    scheduled = false;
    let clearance = 0;
    document.querySelectorAll(barSelector).forEach((bar) => {
      if (bar.classList.contains('rabaq-sticky-cart--drawer-open')) return;
      if (bar.matches('sticky-add-cart') && !bar.classList.contains('show-sticky-cart') && !bar.classList.contains('rabaq-cart-sticky')) return;
      const style = window.getComputedStyle(bar);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
      const rect = bar.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1 || rect.top >= window.innerHeight || rect.bottom < window.innerHeight - 100) return;
      clearance = Math.max(clearance, Math.ceil(window.innerHeight - rect.top));
    });
    const value = `${clearance}px`;
    if (button.style.getPropertyValue('--rabaq-wa-clearance') !== value) button.style.setProperty('--rabaq-wa-clearance', value);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }
  function observeBars() {
    if (mutationObserver) mutationObserver.disconnect();
    if (resizeObserver) resizeObserver.disconnect();
    mutationObserver = new MutationObserver(schedule);
    resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null;
    document.querySelectorAll(barSelector).forEach((bar) => {
      mutationObserver.observe(bar, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
      if (resizeObserver) resizeObserver.observe(bar);
    });
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', observeBars);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeBars, { once: true });
  else observeBars();
})();
